module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAAAXNSR0IArs4c6QAAAKJJREFUGBljZGBgYLx9+3YikLYA4gmqqqrXgDQcXL9+XZiZmbkQJPD3799+TU3Nt3BJIAOoVwtIFfz///+4mpraAsZbt25NYGRkzAcpAgo+AbKNgIa+BvFBACi/GigWAmID5dcCNYHZID7QMFGg2DmgvAxUfhITiEEC+E9ILSNQAdjLQJusgTb1YvMyCwtLMcigP3/+9GLzMlBvMVDvUaDe+QBDCEkm/ocARQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/member/icon_more.png
// module id = 9Myn
// module chunks = 2